import React from "react";
import { disregardReasons } from "_constants";
import cx from "classnames";
import { Field } from "formik";
import FormFooter from "forms/components/FormFooter";
import { DateField, DropdownField, TextareaField } from "forms/fields";
import PropTypes from "prop-types";

import SubmitButton from "components/SubmitButton";
import Translate from "utils/translate";

import dealCancelStyles from "./DealCancelForm.css";
import styles from "forms/forms.css";

const { t } = new Translate("DealCancel");

const DealCancelForm = ({ handleSubmit, loading }) => (
  <form className={cx(styles.form, dealCancelStyles.root)} onSubmit={handleSubmit}>
    <Field
      component={DropdownField}
      label={t("reason")}
      name="reason"
      valueExtractor={(v) => t(`disregard_reasons.${v}`)}
      values={disregardReasons}
    />
    <Field component={DateField} label={t("cancelDate")} name="cancelDate" isInput />
    <Field component={DateField} label={t("moveDate")} name="moveDate" isInput />
    <Field component={TextareaField} name="feedback" placeholder={t("feedbackPlaceholder")} />
    <p>{t("feedbackInfo")}</p>
    <FormFooter>
      <SubmitButton
        isSubmitting={loading}
        submitLabel={t("confirm")}
        submittingLabel={t("confirming")}
      />
    </FormFooter>
  </form>
);

DealCancelForm.propTypes = {
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
};

export default DealCancelForm;
